module.exports = __webpack_public_path__ + "img/category-casino-hover.bedd47fb.png";